import { SignIn } from '@clerk/clerk-react';

/**
 * Login page using Clerk's pre-built SignIn component.
 * Replaces the custom login form with Clerk's UI.
 */
export default function Login() {

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-600 to-indigo-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <SignIn
          fallbackRedirectUrl="/dashboard"
          signUpUrl="/sign-up"
        />
      </div>
    </div>
  );
}
